// @flow
import * as React from 'react';
import styled from 'styled-components';
import { values, bindAll, isEmpty, get, toPairs } from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SidebarWidget from '../SidebarWidget';

import Plus from '../../components/Icons/Plus';
import colors from '../../assets/css/colors';
import { below } from "../../assets/css/media";
import { PlayerInfoWithoutPopup, RotatedLabel, Select } from '../index';
import type { TRootStore } from "../../modules/types";
import * as selectors from "../../modules/selectors";
import type { TPositionsById } from "../../modules/types/position";

const TeamViewContent = styled.div`
	background:
		linear-gradient(white 30%, rgba(255,255,255,0)),
		linear-gradient(rgba(255,255,255,0), white 70%) 0 100%,
		radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.2), rgba(0,0,0,0)),
		radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0)) 0 100%;
	background-repeat: no-repeat;
	background-color: white;
	background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
	background-attachment: local, local, scroll, scroll;

`;

const SelectWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px 20px 20px 20px;
	> div {
		flex-basis: 100%;
	}

	${below.tablet`
		flex-wrap: wrap;
		> div {
			flex-basis: 100%;
			margin-bottom: 10px;
		}
	`};
`;

const TeamItemContent = styled.div`
	position: relative;
	height: 60px;
	border-bottom: 1px solid white;
	display: flex;

`;

const EmptyPlayerItem = styled.div`
	cursor: pointer;
	background:${colors.lightGreen};
	width: calc(100% - 20px);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	display: flex;

`;

const EmptyFieldIcon = styled.div`
	margin-left: 65px;
`;

const EmptyFieldText = styled.div`
	margin-left: 1em;
`;

type Props = {
	onToggle: Function,
	onFilterByPosition: Function,
	setPlayer: Function,
	widget_open: boolean,
	teams: Object,
	title: string,
	positions: TPositionsById,
	league: Object,
	teams: Object,
}

type State = {
	selected_team: number | typeof undefined,
};

class TeamViewWidgetContainer extends React.Component<Props, State> {
	state = {
		selected_team: undefined
	};

	componentDidMount() {
		bindAll(this, [
			'changeTeam',
		]);
	}

	changeTeam(evt: Object) {
		this.setState({
			selected_team: evt.currentTarget.value
		});
	}

	get lineup(){
		const {	league, teams } = this.props;
		const { selected_team } = this.state;
		const current_team = selected_team || league.team_id || '';

		return toPairs(get(teams, `${current_team}.lineup`, {}));
	}

	render() {
		const {
			widget_open,
			title,
			teams,
			league,
			onToggle,
			positions,
		} = this.props;

		const teams_arr = values(teams) || [];
		const { selected_team } = this.state;

		if(isEmpty(teams) || isEmpty(league)) {
			return (
				<SidebarWidget
					icon={<Plus/>}
					title={title}
					widget_open={widget_open}
					onToggle={onToggle}
					no_padding={true}
				>
					<SelectWrapper>
						Loading, please wait...
					</SelectWrapper>
				</SidebarWidget>
			);
		}

		const current_team = selected_team || league.team_id;
		const { onFilterByPosition, setPlayer } = this.props;

		return (
			<SidebarWidget
				icon={<Plus/>}
				title={title}
				widget_open={widget_open}
				onToggle={onToggle}
				no_padding={true}
			>
				<div>
					<SelectWrapper>
						<div>
							<Select
								onChange={this.changeTeam}
								value={current_team}
								is_disabled={false}
							>
								{ teams_arr.map(team => (
									<option key={team.id} value={team.id}>
										{ team.id === league.team_id ? 'My team' : team.name }
									</option>
								)) }
							</Select>
						</div>
					</SelectWrapper>
					<TeamViewContent>
						{ this.lineup.map(([key, line]) => line.map((player, index) => (
							<TeamItemContent key={key + index}
								onClick={() => setPlayer(player)}>
								<RotatedLabel
									text={get(positions, `${key}.short_name`, key).toUpperCase()}
								/>
								{ player ? (
									<PlayerInfoWithoutPopup
										className="player-info" player={player} />
								) : (
									<EmptyPlayerItem onClick={() => onFilterByPosition(key)}>
										<EmptyFieldIcon>
											<Plus />
										</EmptyFieldIcon>
										<EmptyFieldText>
											Add a Player
										</EmptyFieldText>
									</EmptyPlayerItem>
								) }
							</TeamItemContent>
						))) }
					</TeamViewContent>
				</div>
			</SidebarWidget>
		);
	}
}

const mapStateToProps = (state: TRootStore, props) => ({
	positions: selectors.positions.getPositionsById(state),
	teams: selectors.complex.team.getTeamsWithFullLineupWithPlayers(state, props)
});

export const TeamViewWidget = withRouter(connect(
	mapStateToProps,
)(TeamViewWidgetContainer));

export default TeamViewWidget;


// WEBPACK FOOTER //
// ./src/components/TeamViewWidget/index.js